import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgxSliderModule, Options} from '@angular-slider/ngx-slider';
import {fromEvent, Subject, Subscription} from 'rxjs';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import {empty} from '../../../functions';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-view-range-slider',
    templateUrl: './view-range-slider.component.html',
    styleUrls: ['./view-range-slider.component.scss'],
    standalone: true,
    imports: [NgxSliderModule, FormsModule, CommonModule, FontAwesomeModule]
})
export class ViewRangeSliderComponent implements OnInit {


  faTimes = faTimes;

  @Input() title = '';

  @Input() resetListener:Subject<any> = new Subject();
  resetSubscription: Subscription;

  @Input() minValue = 0;
  @Input() maxValue = 10000;

  sliderOptions : Options = {
    floor: this.minValue ?? 0,
    ceil: this.maxValue ?? 10000
  }

  public upperValue: number = this.minValue;
  public lowerValue: number = this.maxValue;

  @Output() valuesOutput = new EventEmitter();

  // @ts-ignore
  @ViewChild('inputLowerValue') inputLowerValue: ElementRef;
  // @ts-ignore
  @ViewChild('inputUpperValue') inputUpperValue: ElementRef;

  constructor() {

   this.resetSubscription = this.resetListener.subscribe( (next) => {

    });

  }

  ngOnInit(): void {

  }

  ngAfterViewInit()
  {

    // server-side search
    fromEvent(this.inputLowerValue.nativeElement,'input')
      .pipe(
        filter(Boolean),
        debounceTime(1000),
        distinctUntilChanged(),
        tap((text) => {
          this.lowerInputValueChanged(this.inputLowerValue.nativeElement.value)
        })
      )
      .subscribe();

    // server-side search
    fromEvent(this.inputUpperValue.nativeElement,'input')
      .pipe(
        filter(Boolean),
        debounceTime(1000),
        distinctUntilChanged(),
        tap((text) => {
          this.upperInputValueChanged(this.inputUpperValue.nativeElement.value)
        })
      )
      .subscribe();

  }

  lowerValueChanged($event: any) {

    this.lowerValue = parseInt($event, 10);

    if (this.lowerValue) {
      if (!this.upperValue) {
        this.upperValue = this.maxValue;
      }
      if (this.upperValue !== null && this.upperValue < this.lowerValue) {
        this.upperValue = this.lowerValue;
      }
    } else {
      this.upperValue = this.maxValue;
    }


  }

  upperValueChanged($event: any) {

    this.upperValue = parseInt($event, 10);
    if (this.upperValue) {
      if (!this.lowerValue) {
        this.lowerValue = 0;
      }
    }


  }

  handleSliderChanges()
  {
    this.valuesOutput.emit({
      lowerValue: this.lowerValue,
      upperValue: this.upperValue
    });
  }

  reset() {
    this.lowerValue = this.minValue;
    this.upperValue = this.maxValue;

    this.valuesOutput.emit({
      lowerValue: null,
      upperValue: null
    });
  }

  lowerInputValueChanged($value: any)
  {
    if (!empty($value)) {
        this.lowerValue = parseInt($value, 10);
    } else {
      this.lowerValue = 0;
    }

    this.handleSliderChanges();

  }

  upperInputValueChanged($value: any)
  {
    if (!empty($value)) {
      this.upperValue = parseInt($value, 10);
    } else {
      this.upperValue = 0;
    }

    this.handleSliderChanges();

  }

}
